export enum PowerOfAttorneyLegitimationCodeType {
    OWNER = 1,
    AUTHORIZED_REPRESENTATIVE = 2,
    HOLDER_PARENTAL_AUTHORITY = 9,
    CO_OWNER = 49,
}
